import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "dns-checker",
  title: "DNS Checker",
  description:
    "Check DNS records across public resolvers to compare propagation, response details, and lookup speed.",
  category: "SEO",
} satisfies ToolMeta;
